import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminPage } from '../pages/AdminPage/AdminPage';
import { msalInstance } from '../api/auth';

export const Route = createFileRoute('/admin')({
  component: AdminPage,
  beforeLoad: () => {
    const account = msalInstance.getActiveAccount();
    const roles = account?.idTokenClaims?.roles || [];

    if (!roles.includes('Manage.All')) {
      throw redirect({
        to: '/',
        search: { error: 'insufficient_permissions' },
      });
    }
  },
});
